export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/online_coding_lessons.255322b.svg";